// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1wYTt","options":"AnswerScale_options__1yIfF","selected":"AnswerScale_selected__1_A4I"};